// import $ from "jquery";
import slick from "slick-carousel";
import matchHeight from "jquery-match-height";
import {
  breakpoints,
  matchBreakpoint,
  slickItemsCounter
} from "../common/utils";

(() => {
  const slickInit = {
    init() {
      this.twoSlide();
      this.twoSlideCategory();
      this.threeSlide();
      this.fourSlide();
      this.fourSlideVideoBlog();
      this.threeSlideBlog();
      this.latestPosts();
      this.productLoop();
      this.blogGallery();
      this.blogContent();
      //this.blogVideo();
      this.stepsSlider();
      this.productHomeSlider();
      this.productSectorsSlider();
      this.bundlesSlider();
      this.testimonialsSlider();
      //this.adviceSlider();
      this.blogProductSlider();

      if ($(".home-product-slider__slider--sectors").length) {
        $(window).resize(() => {
          let $windowWidth = $(window).width();

          if ($windowWidth > 500) {
            if (
              $(".home-product-slider__slider--sectors").hasClass(
                "slick-initialized"
              )
            ) {
              $(".home-product-slider__slider--sectors").slick("unslick");
            }

            this.productSectorsSlider();
          }
        });
      }
    },
    threeSlide() {
      const slider = $(".three-slide");

      slider.slick({
        speed: 600,
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: false,
        variableWidth: true,
        prevArrow:
          '<span class="three-slide__arrow three-slide__arrow--prev"></span>',
        nextArrow:
          '<span class="three-slide__arrow  three-slide__arrow--next"></span>',
        responsive: [
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
    },
    threeSlideBlog() {
      const slider = $(".three-slide-blog");

      slider.slick({
        speed: 600,
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        variableWidth: false,
        prevArrow:
          '<span class="three-slide__arrow three-slide__arrow--prev"></span>',
        nextArrow:
          '<span class="three-slide__arrow  three-slide__arrow--next"></span>',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              variableWidth: true,
              slidesToShow: 1
            }
          }
        ]
      });
    },
    twoSlide() {
      const slider = $(".two-slide");

      slider.slick({
        speed: 600,
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: false,
        prevArrow:
          '<span class="three-slide__arrow three-slide__arrow--prev"></span>',
        nextArrow:
          '<span class="three-slide__arrow  three-slide__arrow--next"></span>',
        responsive: [
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
    },
    twoSlideCategory() {
      const slider = $(".two-slide-category");

      slider.slick({
        speed: 600,
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: false,
        prevArrow:
          '<span class="three-slide__arrow three-slide__arrow--prev"></span>',
        nextArrow:
          '<span class="three-slide__arrow  three-slide__arrow--next"></span>',
        responsive: [
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 1.2
            }
          }
        ]
      });
    },
    fourSlide() {
      const slider = $(".four-slide");

      slider.slick({
        speed: 600,
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        variableWidth: true,
        prevArrow:
          '<span class="four-slide__arrow four-slide__arrow--prev"></span>',
        nextArrow:
          '<span class="four-slide__arrow  four-slide__arrow--next"></span>',
        responsive: [
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 400,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
    },
    fourSlideVideoBlog() {
      const slider = $(".four-slide-video-blog");

      slider.slick({
        speed: 600,
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        variableWidth: false,
        prevArrow:
          '<span class="four-slide__arrow four-slide__arrow--prev"></span>',
        nextArrow:
          '<span class="four-slide__arrow  four-slide__arrow--next"></span>',
        responsive: [
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 400,
            settings: {
              variableWidth: true,
              slidesToShow: 1
            }
          }
        ]
      });
    },
    productHomeSlider() {
      const slider = $(".home-product-slider__slider");

      slider.slick({
        speed: 600,
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        variableWidth: true,
        prevArrow:
          '<span class="home-product-slider__arrow home-product-slider__arrow--prev"></span>',
        nextArrow:
          '<span class="home-product-slider__arrow  home-product-slider__arrow--next"></span>',
        responsive: [
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 400,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
    },
    productSectorsSlider() {
      const slider = $(".home-product-slider__slider--sectors");

      slider.slick({
        speed: 600,
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        variableWidth: true,
        prevArrow:
          '<span class="home-product-slider__arrow home-product-slider__arrow--prev"></span>',
        nextArrow:
          '<span class="home-product-slider__arrow  home-product-slider__arrow--next"></span>',
        responsive: [
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 576,
            settings: "unslick"
          }
        ]
      });
    },
    productAdviceSlider() {
      const slider = $(".advice-slider__slider");

      slider.slick({
        speed: 600,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        variableWidth: false,
        prevArrow:
          '<span class="advice-slider__arrow advice-slider__arrow--prev"></span>',
        nextArrow:
          '<span class="advice-slider__arrow  advice-slider__arrow--next"></span>',
        responsive: [
          {
            breakpoint: 1020,
            settings: {
              variableWidth: true
            }
          }
        ]
      });
    },
    productVideoSlider() {
      const slider = $(".advice-slider__video-slider");

      slider.slick({
        speed: 600,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        prevArrow:
          '<span class="advice-slider__arrow advice-slider__arrow--prev"></span>',
        nextArrow:
          '<span class="advice-slider__arrow  advice-slider__arrow--next"></span>'
      });
    },
    blogProductSlider() {
      const slider = $(".single-product-blocks__slider");

      slider.slick({
        speed: 600,
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        variableWidth: true,
        prevArrow:
          '<span class="single-product-blocks__arrow single-product-blocks__arrow--prev"></span>',
        nextArrow:
          '<span class="single-product-blocks__arrow  single-product-blocks__arrow--next"></span>',
        responsive: [
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 400,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
    },
    bundlesSlider() {
      const slider = $(".bundles-slider__slider");

      slider.slick({
        speed: 600,
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        variableWidth: true,
        prevArrow:
          '<span class="bundles-slider__arrow bundles-slider__arrow--prev"></span>',
        nextArrow:
          '<span class="bundles-slider__arrow  bundles-slider__arrow--next"></span>',
        responsive: [
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 400,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
    },
    testimonialsSlider() {
      const slider = $(".testimonials__slider");

      slider.slick({
        speed: 600,
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        variableWidth: true,
        prevArrow:
          '<span class="testimonials__arrow testimonials__arrow--prev"></span>',
        nextArrow:
          '<span class="testimonials__arrow  testimonials__arrow--next"></span>',
        responsive: [
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 400,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
    },
    academySlider() {
      const slider = $(".academy__slider");

      slider.slick({
        speed: 600,
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        variableWidth: true,
        prevArrow: '<span class="academy__arrow academy__arrow--prev"></span>',
        nextArrow: '<span class="academy__arrow  academy__arrow--next"></span>',
        responsive: [
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 400,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
    },
    latestPosts() {
      const slider = $("[data-posts-slider]");

      if (!matchBreakpoint(breakpoints.md, "max")) {
        return;
      }

      slider.slick({
        dots: false,
        infinite: false,
        speed: 600,
        arrows: false,
        slidesToShow: 1.2,
        slidesToScroll: 1
      });
    },
    blogGallery() {
      const slider = $("[data-gallery-slider]");
      const sliderNav = $("[data-gallery-slider-nav]");

      slider.slick({
        dots: false,
        draggable: false,
        infinite: false,
        speed: 600,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        asNavFor: sliderNav
      });
      sliderNav.slick({
        slidesToShow: 4.5,
        slidesToScroll: 1,
        dots: false,
        focusOnSelect: true,
        infinite: false,
        arrows: true,
        prevArrow:
          '<span class="blog-slider-arrows blog-slider-arrows--prev"></span>',
        nextArrow:
          '<span class="blog-slider-arrows blog-slider-arrows--next"></span>',
        asNavFor: slider,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3.5,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2.5,
              slidesToScroll: 1
            }
          }
        ]
      });
    },
    blogContent() {
      const slider = $("[data-blog-content]");

      slider.on("init reInit afterChange", slickItemsCounter);

      slider.slick({
        dots: false,
        infinite: false,
        speed: 600,
        slidesToShow: 2.5,
        slidesToScroll: 2,
        prevArrow:
          '<span class="blog-slider-arrows blog-slider-arrows--prev"></span>',
        nextArrow:
          '<span class="blog-slider-arrows blog-slider-arrows--next"></span>',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1.2,
              slidesToScroll: 1
            }
          }
        ]
      });
    },
    stepsSlider() {
      const slider = $(".steps-slider-for");
      const sliderNav = $(".steps-slider-nav");

      slider.slick({
        dots: false,
        draggable: false,
        infinite: true,
        speed: 600,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: $(".step-prev"),
        nextArrow: $(".step-next"),
        asNavFor: sliderNav,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              prevArrow: false,
              nextArrow: false
            }
          },
          {
            breakpoint: 480,
            settings: {
              arrows: false,
              prevArrow: false,
              nextArrow: false
            }
          }
        ]
      });
      sliderNav.slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        centerPadding: "7px",
        dots: false,
        centerMode: false,
        focusOnSelect: true,
        arrows: false,
        infinite: false,
        asNavFor: slider,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              prevArrow: false,
              nextArrow: false
            }
          },
          {
            breakpoint: 480,
            settings: {
              arrows: false,
              prevArrow: false,
              nextArrow: false
            }
          }
        ]
      });
      $(".steps-slider-nav, .steps-slider-for").on("click", function(event) {
        event.preventDefault();
        event.stopPropagation();
      });
      $("a[data-slide]").each(function() {
        let self = $(this);

        self.removeClass("open");

        self.on("click", function(event) {
          event.preventDefault();
          event.stopPropagation();
          let slideno = self.data("slide");

          sliderNav.slick("slickGoTo", slideno - 1);
          setTimeout(function() {
            $(".js-lightbox-slider").addClass("open");
            $("body").addClass("scrollLock");
            $("main").addClass("z-index-100");
          }, 450);
        });
      });
    },
    blogVideo() {
      const slider = $("[data-new-slider]");

      slider.each(function() {
        let self = $(this);
        const sliderData = self.data("new-slider");
        const dataSlides = self.parent().find("[data-" + sliderData + "]");
        let sliderSlides = dataSlides.data(sliderData);
        let sliderSlidesMobile = 1;
        let sliderSlidesIpad = 1;
        let sliderSlidesIpadPro = 1;
        let arrNext = $(".blog-slider-arrows--next");

        self.on("init reInit afterChange", function(
          event,
          slick,
          currentSlide
        ) {
          if (
            slick.$slides.length > 1 &&
            slick.$slides.length == currentSlide + slick.options.slidesToScroll
          ) {
            self.addClass("show-mask");
          } else {
            self.removeClass("show-mask");
          }

          if (
            (!self.find(".blog-slider-arrows--next").length > 0 ||
              self
                .find(".blog-slider-arrows--next")
                .hasClass("slick-disabled")) &&
            self.find(".blog-slider-arrows--prev").length > 0
          ) {
            self.addClass("hide-after");
          } else {
            self.removeClass("hide-after");
          }
        });

        if (sliderSlides != 1) {
          self.removeClass("video-slider--large");
          sliderSlidesMobile = 1.5;
          sliderSlidesIpad = 2.5;
          sliderSlidesIpadPro = 3.5;
        }

        if (sliderSlides >= 3 && !self.hasClass("const-num")) {
          sliderSlides = 3.5;
        }

        if ($("[data-video-slider-slides]").hasClass("video-full")) {
          sliderSlides = 4;
        }

        self.slick({
          dots: false,
          infinite: false,
          speed: 600,
          slidesToShow: sliderSlides,
          slidesToScroll: 2,
          centerPadding: "20px",
          prevArrow:
            '<span class="blog-slider-arrows blog-slider-arrows--prev"></span>',
          nextArrow:
            '<span class="blog-slider-arrows blog-slider-arrows--next"></span>',
          responsive: [
            {
              breakpoint: 1100,
              settings: {
                slidesToShow: sliderSlidesIpadPro,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 799,
              settings: {
                slidesToShow: sliderSlidesIpad,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: sliderSlidesMobile,
                slidesToScroll: 1
              }
            }
          ]
        });
      });
    },
    productLoop() {
      const slider = $("[data-loop-products]");

      slider.on("init reInit afterChange", slickItemsCounter);

      slider.slick({
        dots: true,
        infinite: false,
        speed: 600,
        slidesToShow: 3,
        slidesToScroll: 3,
        prevArrow:
          '<span class="c-box-top-products__arrows c-box-top-products__arrows--prev"></span>',
        nextArrow:
          '<span class="c-box-top-products__arrows c-box-top-products__arrows--next"></span>',
        dotsClass: "c-box-top-products__dots",
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1.2,
              slidesToScroll: 1
            }
          }
        ]
      });
    }
  };

  slickInit.init();
})();
